import { useState, FormEvent } from 'react';
import styles from './LoginBox.module.css';

interface LoginBoxProps {
    login(username: string, password: string): void;
    error?: string;
}

export function LoginBox({ login, error }: LoginBoxProps) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        login(username, password);
    };

    return (
        <div className={styles.container}>
            {error && <div className={styles.error}>{error}</div>}
            <form className={styles.form} onSubmit={handleSubmit}>
                <table className={styles.table}>
                    <tbody>
                        <tr>
                            <td>
                                <span className={styles.fieldTitle}>Username:</span>
                            </td>
                            <td>
                                <input
                                    type="text"
                                    name="username"
                                    className={styles.input}
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span className={styles.fieldTitle}>Password:</span>
                            </td>
                            <td>
                                <input
                                    type="password"
                                    name="password"
                                    className={styles.input}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <input
                                    type="submit"
                                    value="Login"
                                    className={styles.submitButton}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    );
}
